import { AddNewWidgetModal } from "./AddNewWidgetModal";

export default AddNewWidgetModal;
